import { TapAuth } from './tap-auth';

export const INITIAL_SESSION_STATE: TapAuth.SessionState = {
  groupId: 0,
  lifeTime: -1,
  name: 'anonymous',
  startTime: undefined,
  profileId: 0,
  profileName: 'anonymous',
};

export const PASSWORD_LENGTH = 16;
